import React, { Fragment, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ComposedChart, Line, Area, Label, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Scatter, ResponsiveContainer } from 'recharts';
import Title from './Title';
import { formatSalaryChartData } from '../utils/formatData';

const data = [
  {
    name: 'Page A',
    uv: 590,
    pv: 800,
    amt: 1400,
    cnt: 490,
  },
  {
    name: 'Page B',
    uv: 868,
    pv: 967,
    amt: 1506,
    cnt: 590,
  },
  {
    name: 'Page C',
    uv: 1397,
    pv: 1098,
    amt: 989,
    cnt: 350,
  },
  {
    name: 'Page D',
    uv: 1480,
    pv: 1200,
    amt: 1228,
    cnt: 480,
  },
  {
    name: 'Page E',
    uv: 1520,
    pv: 1108,
    amt: 1100,
    cnt: 460,
  },
  {
    name: 'Page F',
    uv: 1400,
    pv: 680,
    amt: 1700,
    cnt: 380,
  },
];

export default function AltChart({ chartTitle, chartData }) {
  const theme = useTheme();

  const displayData = formatSalaryChartData(chartData);
  return (
    <Fragment>
      <Title>{chartTitle}</Title>
      <ResponsiveContainer width='100%' height='100%'>
        <ComposedChart
          width={500}
          height={400}
          data={displayData}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          {/* <CartesianGrid stroke='#f5f5f5' /> */}
          <XAxis dataKey='year' scale='band' />
          <YAxis stroke={theme.palette.text.secondary} style={theme.typography.body2}>
            <Label
              angle={270}
              position='left'
              style={{
                textAnchor: 'middle',
                fill: theme.palette.text.primary,
                ...theme.typography.body1,
              }}
            >
              Avg Salary ($)
            </Label>
          </YAxis>
          <CartesianGrid stroke='#eee' strokeDasharray='5 5' />
          <Tooltip />
          <Legend />
          {/* <Area type='monotone' dataKey='amt' fill='#8884d8' stroke='#8884d8' /> */}
          {/* <Bar dataKey='teaching_staff_cnt' barSize={20} fill='#413ea0' />
          <Bar dataKey='administrative_staff_cnt' barSize={20} fill='#213ea0' /> */}
          <Line name='Teacher' type='monotone' dataKey='teaching_staff_avg' stroke='blue' />
          <Line name='Principal' type='monotone' dataKey='principal_avg' stroke='green' />
          <Line name='Admin' type='monotone' dataKey='administrative_staff_avg' stroke='orange' />
          <Line name='Superintendent' type='monotone' dataKey='superintendent_avg' stroke='#8884d8' />
          {/* <Scatter dataKey='cnt' fill='red' /> */}
        </ComposedChart>
      </ResponsiveContainer>
    </Fragment>
  );
}
